import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconStackedBarChartAxis2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconStackedBarChartAxis2"><Path d="M4.5 19.5H21V21H3V3H4.5V19.5Z" fill="currentColor"/><Path d="M12 18H7V9H12V18Z" fill="currentColor"/><Path d="M18 18H13V6H18V18Z" fill="currentColor"/></CentralIconBase>;
});

export default IconStackedBarChartAxis2;
